/**
 * Equipes do GERENTE (AN-8 §1, V56 — módulo oportunidades). 1 equipe ativa por gerente;
 * consultor em no máximo 1 equipe ativa; equipe sem tenant (Q-AN8-3). Escrita ADMIN; o
 * GERENTE com GESTOR_EQUIPE lê só a própria.
 */
export interface Equipe {
  id: string
  nome: string
  gerente: { id: string; nome?: string | null }
  ativa: boolean
  /** Quantidade de membros ativos (vem do backend). */
  membros: number
  criadoEm: string
  atualizadoEm?: string | null
}

/** `POST/PUT /v1/equipes` — nome 1..120; gerente ativo com GERENTE na projeção. */
export interface EquipeRequest {
  nome: string
  gerenteId: string
}

/** `GET /v1/equipes/{id}/membros`. */
export interface MembroEquipe {
  consultorId: string
  nome?: string | null
  canal?: string | null
  tenantId?: string | null
  incluidoEm: string
}

export type TipoCandidatoEquipe = 'GERENTE' | 'CONSULTOR'

/** `GET /v1/equipes/candidatos?tipo=&busca=` (ADMIN, da projeção de usuários). */
export interface CandidatoEquipe {
  usuarioId: string
  nome?: string | null
  email?: string | null
  canal?: string | null
  tenantId?: string | null
  /** Equipe ativa em que o usuário já está (consultor) ou que já gerencia (gerente). */
  equipeId?: string | null
}

export const NOME_EQUIPE_MAX = 120

/** Texto de apoio quando o backend não manda `message`. */
export const ERRO_EQUIPE_ROTULO: Record<string, string> = {
  GERENTE_INVALIDO: 'O gerente escolhido não está ativo com o papel GERENTE',
  GERENTE_JA_TEM_EQUIPE: 'Este gerente já tem uma equipe ativa',
  EQUIPE_INATIVA: 'A equipe está desativada',
  EQUIPE_NOT_FOUND: 'Equipe não encontrada',
  CONSULTOR_INVALIDO: 'Consultor inválido ou inativo',
  CONSULTOR_JA_EM_EQUIPE: 'Um dos consultores já está em outra equipe',
  EQUIPE_FORA_DO_ESCOPO: 'Equipe fora do seu escopo',
}

export const mensagemErroEquipe = (e: unknown, padrao: string): string => {
  const env = e as { message?: string; data?: { errorCode?: string; message?: string } } | null
  const msg = env?.message ?? env?.data?.message
  if (msg) return msg
  const codigo = env?.data?.errorCode
  return (codigo && ERRO_EQUIPE_ROTULO[codigo]) || padrao
}
